import React, { useEffect, useState } from 'react';
import Wishlist from '../Components/WishList/Wishlist';
import Header from '../Components/Header/Header';
import { useLocation } from 'react-router-dom';

// Preloader component
const Preloader = () => (
  <div style={{
    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    backgroundColor: 'white', zIndex: 9999
  }}>
    <div className="spinner-border " style={{ width: '3rem', height: '3rem' , color: '#92ad69' }}role="status">
      <span className="sr-only">Loading...</span>
    </div>
  </div>
);

const Wishlistpage = () => {
  const [cartRefresh, setCartRefresh] = useState(false);
  const [loading, setLoading] = useState(true);

  const refreshCart = () => {
    setCartRefresh((prev) => !prev);
  };

  const routePath = useLocation();

  const onTop = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    onTop();
  }, [routePath]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 1500); // Show loader for 1 second (adjustable)
    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      {loading && <Preloader />}
      <Header cartRefresh={cartRefresh} />
      <Wishlist onCartUpdate={refreshCart} />
    </>
  );
};

export default Wishlistpage;
